// A link inside the partner page that moves the page itself, with no router.
import { TextLink } from '@olytic/foundation';
import type { MouseEvent } from 'react';

/** True for a plain left click: modified clicks (new tab, new window) are left to the browser. */
export function isPlainClick(event: MouseEvent<HTMLElement>): boolean {
  return !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0);
}

/** A link that is a real link (open in a new tab works) but moves the page itself on a plain click. */
export function PageLink({ path, go, children }: { path: string; go: (path: string) => void; children: string }): JSX.Element {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!isPlainClick(event)) return;
    event.preventDefault();
    go(path);
  };
  return (
    <TextLink href={path} onClick={onClick}>
      {children}
    </TextLink>
  );
}
